import { UserInfo } from '@/components/cards/UserInfo';
import StackedBarChart from '@/components/chart/StackedBarChart';
import { Button } from '@/design-system/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/design-system/select';
import { useDynamicLocale } from '@/hoslog-intl';
import { ChevronLeft, ChevronRight } from '@/icons';
import { exportToCSV } from '@/lib/exportToCSV';
import { OverViewSalesBreakdownProps } from '@/services/dashboard/overview/overview.types';
import { ArrowRightCircleIcon } from 'lucide-react';
import { useState } from 'react';

export const OverViewSalesBreakdown = ({
  topAffiliateRanks,
  dataset,
  categoryMeta,
  data,
}: OverViewSalesBreakdownProps) => {
  const onExport = () => {
    exportToCSV(data, {
      filename: `sales-breakdown.csv`,
      excludeColumns: ['select', 'actions'],
      onlySelected: false,
    });
  };
  const { t } = useDynamicLocale();
  const [sortBy, setSortBy] = useState('2024');
  const sortOptions = [
    { value: '2024', label: '2024年の売上' },
    { value: '2023', label: '2023年の売上' },
    { value: '2022', label: '2022年の売上' },
  ];
  return (
    <>
      <div className="flex mt-6  gap-5.5">
        <div className="w-full bg-card rounded-sm py-6 px-6">
          <div className="flex items-center justify-between mb-8">
            <div className="text-xl font-bold">Plans Usage Analytics</div>
            <div className="flex gap-4">
              <div className="flex items-center gap-1">
                <Button aria-label="Go to previous page" variant="icon" size="icon" className="size-4 ">
                  <ChevronLeft />
                </Button>
                <span className="text-xs font-medium">2024.01.27 ~ 2024.02.04</span>
                <Button aria-label="Go to next page" variant="icon" size="icon" className="size-4">
                  <ChevronRight />
                </Button>
              </div>
              <Button variant={'secondary'} className="bg-surface-hover text-primary-950 shadow-none border-none">
                CSV形式でダウンロード
              </Button>
            </div>
          </div>
          <StackedBarChart t={t} series={categoryMeta} data={dataset} chartId="dashboardOverview" />
        </div>
        <div className="max-w-[344px] w-full min-w-[306px] bg-card p-6 rounded-sm flex flex-col gap-4">
          <div className="text-primary-950 text-lg font-bold leading-8">Top Affiliate Ranking</div>
          <div className="flex flex-col gap-5">
            {topAffiliateRanks?.map((affiliate) => (
              <UserInfo
                key={affiliate.userId}
                name={affiliate.name}
                profile={affiliate.profile}
                reservationCount={affiliate.reservationCount}
                userId={affiliate.userId}
              />
            ))}
          </div>
          <Button
            variant={'link'}
            className="flex items-end justify-end gap-2 text-primary-950 text-sm underline font-bold pr-0"
          >
            スタッフ一覧へ <ArrowRightCircleIcon size={18} />
          </Button>
        </div>
      </div>

      <div>
        <div className="text-lg font-bold">Sales Breakdown</div>
        <div className="flex gap-3 mt-2.5 mb-4">
          <Select value={sortBy} onValueChange={setSortBy}>
            <SelectTrigger id="sort-select" className="bg-card border-none w-[138px] text-xs font-medium">
              <SelectValue placeholder="Select sorting option" />
            </SelectTrigger>
            <SelectContent>
              {sortOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Button onClick={onExport}>CSVダウンロード</Button>
        </div>
      </div>
    </>
  );
};
